import React from 'react'

import firebaseUtil from 'firebaseUtil'
import { useNavigate } from 'react-router-dom'
import useNotification from 'notification';

import DefaultCrudForm from 'components/form/DefaultCrudForm'
import FormContent from 'components/form/FormContent'
import FormRow from 'components/form/FormRow';
import SelectButtonInput from 'components/form/input/SelectButtonInput';
import TextInput from 'components/form/input/TextInput'

import Perfil from 'entity/Perfil'


function CreateUserInter(props) {
    return (<FormContent sx={{ m: 1 }}>
        <FormRow>
            <TextInput name="name" label="Nome" required />
            <TextInput type="email" name="email" label="E-mail" required />
            <TextInput type="password" name="senha" label="Senha" required />
            <TextInput type="password" name="confirmarSenha" label="Confirmar Senha" required />
        </FormRow>
        <FormRow>
            <SelectButtonInput
                name="tipoPerfil"
                label="Perfil"
                options={["admin", "colaborador"]}
                optionsToString={["ADMINISTRADOR", "COLABORADOR"]}
                required
            />
        </FormRow>
    </FormContent>)
}

export default function UserCreate() {
    const navigate = useNavigate();
    const { showWarning, showError } = useNotification()

    const validValues = (values) => {
        // console.log('validValues', values)
        if (values.senha !== values.confirmarSenha) {
            showWarning("As senhas estão diferentes")
            return false
        }

        if (values.email) {
            let isEmailValid = String(values.email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
            if (!isEmailValid) {
                showWarning("Email inválido")
                return false
            }
        }

        return true
    }

    const saveValues = (values) => {
        // console.log('saveValues', values)

        firebaseUtil.registerNoLogin(values.email, values.senha).then(user => {
            // console.log('user', user)

            let perfil = new Perfil()

            perfil.update({
                uid: user.user.uid,
                name: values.name,
                email: values.email,                
                tipoPerfil: values.tipoPerfil,
            })

            perfil.save().then(() => {
                navigate("/perfil?uid=" + user.user.uid)
            })

        }).catch(error => {
            // console.log("error", error)

            switch (error.code) {
                case 'auth/invalid-email':
                    showError('Endereço de e-mail Inválido')
                    break;
                case 'auth/email-already-in-use':
                    showError('Endereço de e-mail já em uso')
                    break;
                case 'auth/weak-password':
                    showError('Senha muito fraca')
                    break;
                // case 'auth/user-disabled':
                //     showError('O usuário pode ter sido desativado')
                //     break;
                // case 'auth/user-not-found':
                //     showError('Não há registro de usuário correspondente a esse identificador. O usuário pode ter sido excluído')
                //     break;
                // case 'auth/wrong-password':
                //     showError('Senha inválida ou o usuário não tem uma senha')
                //     break;
                default:
                    break;
            }
        })
    }
    return (<DefaultCrudForm
        saveValues={saveValues}
        validValues={validValues}
        initialValues={{}}
    >
        {(formProps) => {
            return <CreateUserInter {...formProps} />
        }}
    </DefaultCrudForm>
    )
}
